import { render, staticRenderFns } from "./OrigenDeudaCrud.vue?vue&type=template&id=5f0946f2"
import script from "./OrigenDeudaCrud.vue?vue&type=script&lang=js"
export * from "./OrigenDeudaCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports